import { useTranslation } from 'react-i18next';
import { TIMELINE_PERSON_COLUMN_WIDTH_PX } from '../../utils/timeline-geometry';
import type { TimelineColumn } from '../../types';

interface TimelineWeekHeaderProps {
  columns: TimelineColumn[];
  columnWidthPx: number;
  /** Overrides the default "Persona" label — e.g. "Responsable" when grouped by status/priority/group. */
  personColumnLabel?: string;
}

/** Sticky "Persona"/"Responsable" label + one cell per visible column (day/week/month, per the active zoom). */
export function TimelineWeekHeader({
  columns,
  columnWidthPx,
  personColumnLabel,
}: TimelineWeekHeaderProps) {
  const { t } = useTranslation('tasks');

  return (
    <div
      data-testid="tasks-timeline-week-header"
      className="sticky top-0 z-10 flex items-stretch border-b border-border bg-muted"
    >
      <div
        className="sticky left-0 z-10 flex shrink-0 items-center border-r border-border bg-muted pl-3.5"
        style={{ width: TIMELINE_PERSON_COLUMN_WIDTH_PX, height: 32 }}
      >
        <p className="text-xs font-medium text-muted-foreground">
          {personColumnLabel ?? t('timeline.columns.person')}
        </p>
      </div>
      {columns.map((column) => (
        <div
          key={column.startDate.toISOString()}
          className="flex shrink-0 items-center justify-center border-r border-border"
          style={{ width: columnWidthPx, height: 32 }}
        >
          <p className="whitespace-nowrap text-[11.5px] font-medium text-muted-foreground">
            {column.label}
          </p>
        </div>
      ))}
    </div>
  );
}
